module.exports = __webpack_public_path__ + "fonts/Calibre-MediumItalic.3df14639.woff2";